/**
 * Enumeration representing security options for an API endpoint
 */
export enum Secure {
  /** The endpoint request a JWT token */
  true,

  /** The endpoint is not secure */
  false,

  /** The endpoint is secured with an API key */
  api
}
